import React from 'react';
import defaultImage from "../../public/assets/images/users/1.png";

const TopScorer = ({ pageData = {}, pageObj, settings = {} }) => {

    const getTableRow = () => {
        if (pageData.data) {
            let data = pageData.data.map((data, index) => {
                console.log(data)
                return (
                    <div className="col-md-4 col-sm-4 mb-4 mt-4 "  >
                        <div className='row'>
                            <div className="col-3 card " style={{ marginLeft:'25%', padding:0,  background: 'rgb(188 57 57)',width: '100%', height:'100%', border: '3px solid rgb(188 57 57)'}}
                            //  style={{position:'relative', borderRadius: '50%', border: '4px solid rgb(188 57 57)'}}
                             >
                                <img className='card-header' src={data['img_path'] ? data['img_path'] : defaultImage } alt="Symphony Image"
                                    style={{ padding:0,  width: '100%', height: '100%',
                                    
                                     
                                     }}
                                />
                                <p className='text-center card-body font-weight-bold ' style={{ paddingBottom:'1%',paddingTop:'2%', width: '100%',height: '25px', marginTop:'83%', position:'absolute', background: 'rgb(188 57 57)',color: 'white'}}>{ data['rank']}</p>  
                            </div>
                           
                            <div className="col-md-6 py-2 border-left" style={{ marginTop: '5%' }}>
                                 <h3 style={{color: '#1389ad'}}>{data['names']}</h3> 
                                <h2 className='font-weight-bold' style={{paddingLeft: '10%'}}>{data['score']}</h2>
                            </div>
                        </div>

                    </div>
                )
            });

            return data
        }
    }

        return (
            <div className="container-fluid my-1">
                <div className="col-md-12 float-left text-center pr-5">
                    <p className="display-6 font-weight-bold">
                        {pageData && pageData.title && pageData.title}
                    </p>
                     <span className="hor-bar"/>
                </div>
                <div className="col-md-12">
                    <div className="row" >
                        {getTableRow()}
                    </div>
                </div>
            </div>
        )

};
export default TopScorer;



// WEBPACK FOOTER //
// ./src/components/agencyMonitor/TopScorer.js